var _g, _circle, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "152.32 281.82 75.6 75.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2857_15080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.557 355.3L223.678 357.421L227.921 353.178L225.8 351.057L221.557 355.3ZM206.379 340.121L221.557 355.3L225.8 351.057L210.621 335.879L206.379 340.121Z",
    fill: "url(#paint0_linear_2857_15080)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186.123,
    cy: 315.623,
    r: 30.8008,
    fill: "white",
    fillOpacity: 0.1,
    stroke: "url(#paint1_linear_2857_15080)",
    strokeWidth: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2857_15080)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2857_15080",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.204 318.758C172.934 319.028 172.928 319.508 173.209 319.789C173.496 320.07 173.975 320.064 174.239 319.8L177.501 316.538L180.756 319.794C181.032 320.07 181.506 320.07 181.787 319.789C182.067 319.502 182.067 319.034 181.792 318.758L178.536 315.503L181.792 312.242C182.067 311.966 182.073 311.492 181.787 311.211C181.506 310.93 181.032 310.93 180.756 311.206L177.501 314.462L174.239 311.206C173.975 310.936 173.49 310.925 173.209 311.211C172.928 311.492 172.934 311.977 173.204 312.242L176.46 315.503L173.204 318.758Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.204 318.758C172.934 319.028 172.928 319.508 173.209 319.789C173.496 320.07 173.975 320.064 174.239 319.8L177.501 316.538L180.756 319.794C181.032 320.07 181.506 320.07 181.787 319.789C182.067 319.502 182.067 319.034 181.792 318.758L178.536 315.503L181.792 312.242C182.067 311.966 182.073 311.492 181.787 311.211C181.506 310.93 181.032 310.93 180.756 311.206L177.501 314.462L174.239 311.206C173.975 310.936 173.49 310.925 173.209 311.211C172.928 311.492 172.934 311.977 173.204 312.242L176.46 315.503L173.204 318.758Z",
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.209 319.789L168.967 324.031L168.987 324.052L169.008 324.072L173.209 319.789ZM177.501 316.538L181.743 312.296L177.501 308.053L173.258 312.296L177.501 316.538ZM181.787 319.789L186.029 324.031L186.05 324.011L186.07 323.99L181.787 319.789ZM178.536 315.503L174.29 311.264L170.055 315.506L174.294 319.745L178.536 315.503ZM181.792 312.242L177.549 307.999L177.546 308.002L181.792 312.242ZM181.787 311.211L177.544 315.454L177.564 315.475L177.585 315.495L181.787 311.211ZM180.756 311.206L176.514 306.963L180.756 311.206ZM177.501 314.462L173.262 318.708L177.504 322.943L181.743 318.704L177.501 314.462ZM174.239 311.206L169.953 315.405L169.977 315.428L170 315.452L174.239 311.206ZM173.209 311.211L177.452 315.454L177.473 315.433L177.493 315.413L173.209 311.211ZM173.204 312.242L177.45 308.002L177.426 307.979L177.403 307.955L173.204 312.242ZM176.46 315.503L180.702 319.745L184.941 315.506L180.706 311.264L176.46 315.503ZM168.961 314.516C166.348 317.129 166.343 321.407 168.967 324.031L177.452 315.546C179.514 317.608 179.52 320.928 177.446 323.001L168.961 314.516ZM169.008 324.072C171.575 326.59 175.823 326.701 178.482 324.042L169.997 315.557C171.136 314.418 172.555 313.994 173.755 313.999C174.974 314.003 176.331 314.446 177.411 315.505L169.008 324.072ZM178.482 324.042L181.743 320.781L173.258 312.296L169.997 315.557L178.482 324.042ZM173.258 320.781L176.514 324.037L184.999 315.551L181.743 312.296L173.258 320.781ZM176.514 324.037C179.162 326.685 183.434 326.626 186.029 324.031L177.544 315.546C179.577 313.513 182.902 313.455 184.999 315.551L176.514 324.037ZM186.07 323.99C188.588 321.423 188.705 317.186 186.035 314.516L177.549 323.001C175.43 320.882 175.547 317.582 177.503 315.587L186.07 323.99ZM186.035 314.516L182.779 311.26L174.294 319.745L177.549 323.001L186.035 314.516ZM182.783 319.742L186.038 316.481L177.546 308.002L174.29 311.264L182.783 319.742ZM186.035 316.484C188.63 313.889 188.696 309.584 185.988 306.928L177.585 315.495C175.45 313.401 175.505 310.044 177.549 307.999L186.035 316.484ZM186.029 306.969C183.434 304.374 179.162 304.315 176.514 306.963L184.999 315.449C182.902 317.545 179.577 317.487 177.544 315.454L186.029 306.969ZM176.514 306.963L173.258 310.219L181.743 318.704L184.999 315.449L176.514 306.963ZM181.74 310.215L178.479 306.96L170 315.452L173.262 318.708L181.74 310.215ZM178.526 307.007C175.936 304.364 171.587 304.297 168.926 307.01L177.493 315.413C176.375 316.553 174.951 317.004 173.709 317C172.489 316.996 171.075 316.549 169.953 315.405L178.526 307.007ZM168.967 306.969C166.367 309.568 166.309 313.887 169.005 316.528L177.403 307.955C178.567 309.096 179 310.528 179 311.733C179 312.952 178.559 314.347 177.452 315.454L168.967 306.969ZM168.958 316.481L172.213 319.742L180.706 311.264L177.45 308.002L168.958 316.481ZM172.217 311.26L168.961 314.516L177.446 323.001L180.702 319.745L172.217 311.26Z",
    fill: "url(#paint2_linear_2857_15080)",
    mask: "url(#path-3-inside-1_2857_15080)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2857_15080)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_2857_15080",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.204 318.758C189.934 319.028 189.928 319.508 190.209 319.789C190.496 320.07 190.975 320.064 191.239 319.8L194.501 316.538L197.756 319.794C198.032 320.07 198.506 320.07 198.787 319.789C199.067 319.502 199.067 319.034 198.792 318.758L195.536 315.503L198.792 312.242C199.067 311.966 199.073 311.492 198.787 311.211C198.506 310.93 198.032 310.93 197.756 311.206L194.501 314.462L191.239 311.206C190.975 310.936 190.49 310.925 190.209 311.211C189.928 311.492 189.934 311.977 190.204 312.242L193.46 315.503L190.204 318.758Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.204 318.758C189.934 319.028 189.928 319.508 190.209 319.789C190.496 320.07 190.975 320.064 191.239 319.8L194.501 316.538L197.756 319.794C198.032 320.07 198.506 320.07 198.787 319.789C199.067 319.502 199.067 319.034 198.792 318.758L195.536 315.503L198.792 312.242C199.067 311.966 199.073 311.492 198.787 311.211C198.506 310.93 198.032 310.93 197.756 311.206L194.501 314.462L191.239 311.206C190.975 310.936 190.49 310.925 190.209 311.211C189.928 311.492 189.934 311.977 190.204 312.242L193.46 315.503L190.204 318.758Z",
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.209 319.789L185.967 324.031L185.987 324.052L186.008 324.072L190.209 319.789ZM194.501 316.538L198.743 312.296L194.501 308.053L190.258 312.296L194.501 316.538ZM198.787 319.789L203.029 324.031L203.05 324.011L203.07 323.99L198.787 319.789ZM195.536 315.503L191.29 311.264L187.055 315.506L191.294 319.745L195.536 315.503ZM198.792 312.242L194.549 307.999L194.546 308.002L198.792 312.242ZM198.787 311.211L194.544 315.454L194.564 315.475L194.585 315.495L198.787 311.211ZM197.756 311.206L193.514 306.963L197.756 311.206ZM194.501 314.462L190.262 318.708L194.504 322.943L198.743 318.704L194.501 314.462ZM191.239 311.206L186.953 315.405L186.977 315.428L187 315.452L191.239 311.206ZM190.209 311.211L194.452 315.454L194.473 315.433L194.493 315.413L190.209 311.211ZM190.204 312.242L194.45 308.002L194.426 307.979L194.403 307.955L190.204 312.242ZM193.46 315.503L197.702 319.745L201.941 315.506L197.706 311.264L193.46 315.503ZM185.961 314.516C183.348 317.129 183.343 321.407 185.967 324.031L194.452 315.546C196.514 317.608 196.52 320.928 194.446 323.001L185.961 314.516ZM186.008 324.072C188.575 326.59 192.823 326.701 195.482 324.042L186.997 315.557C188.136 314.418 189.555 313.994 190.755 313.999C191.974 314.003 193.331 314.446 194.411 315.505L186.008 324.072ZM195.482 324.042L198.743 320.781L190.258 312.296L186.997 315.557L195.482 324.042ZM190.258 320.781L193.514 324.037L201.999 315.551L198.743 312.296L190.258 320.781ZM193.514 324.037C196.162 326.685 200.434 326.626 203.029 324.031L194.544 315.546C196.577 313.513 199.902 313.455 201.999 315.551L193.514 324.037ZM203.07 323.99C205.588 321.423 205.705 317.186 203.035 314.516L194.549 323.001C192.43 320.882 192.547 317.582 194.503 315.587L203.07 323.99ZM203.035 314.516L199.779 311.26L191.294 319.745L194.549 323.001L203.035 314.516ZM199.783 319.742L203.038 316.481L194.546 308.002L191.29 311.264L199.783 319.742ZM203.035 316.484C205.63 313.889 205.696 309.584 202.988 306.928L194.585 315.495C192.45 313.401 192.505 310.044 194.549 307.999L203.035 316.484ZM203.029 306.969C200.434 304.374 196.162 304.315 193.514 306.963L201.999 315.449C199.902 317.545 196.577 317.487 194.544 315.454L203.029 306.969ZM193.514 306.963L190.258 310.219L198.743 318.704L201.999 315.449L193.514 306.963ZM198.74 310.215L195.479 306.96L187 315.452L190.262 318.708L198.74 310.215ZM195.526 307.007C192.936 304.364 188.587 304.297 185.926 307.01L194.493 315.413C193.375 316.553 191.951 317.004 190.709 317C189.489 316.996 188.075 316.549 186.953 315.405L195.526 307.007ZM185.967 306.969C183.367 309.568 183.309 313.887 186.005 316.528L194.403 307.955C195.567 309.096 196 310.528 196 311.733C196 312.952 195.559 314.347 194.452 315.454L185.967 306.969ZM185.958 316.481L189.213 319.742L197.706 311.264L194.45 308.002L185.958 316.481ZM189.217 311.26L185.961 314.516L194.446 323.001L197.702 319.745L189.217 311.26Z",
    fill: "url(#paint3_linear_2857_15080)",
    mask: "url(#path-5-inside-2_2857_15080)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2857_15080",
    x: -341.096,
    y: -175.918,
    width: 2163.06,
    height: 2163.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 523.286,
    dy: 558.964
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 535.38
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2857_15080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2857_15080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2857_15080",
    x: -374.475,
    y: -200.797,
    width: 2150.52,
    height: 2150.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 523.286,
    dy: 558.964
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 535.38
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2857_15080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2857_15080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2857_15080",
    x: -357.475,
    y: -200.797,
    width: 2150.52,
    height: 2150.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 523.286,
    dy: 558.964
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 535.38
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0416667 0 0 0 0 0.1375 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2857_15080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2857_15080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2857_15080",
    x1: 214.743,
    y1: 336.281,
    x2: 214.743,
    y2: 357.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2857_15080",
    x1: 174.775,
    y1: 264.047,
    x2: 174.775,
    y2: 369.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2857_15080",
    x1: 176.702,
    y1: 309.981,
    x2: 176.702,
    y2: 322.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2857_15080",
    x1: 193.702,
    y1: 309.981,
    x2: 193.702,
    y2: 322.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253BFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.67f171e93f75cce67ffa108baf0c294e.svg";
export { ForwardRef as ReactComponent };